import React from 'react';
import { Checkbox } from '@fiverr-private/forms';
import { Text } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { AppI18n } from '../../../i18n';
import { useBriefCreationContext } from '../../../context/BriefCreationContext';
import { ADDITIONAL_WORK_CHECKBOX_ID } from './consts';

export interface AdditionalWorkCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const AdditionalWorkCheckbox: React.FC<AdditionalWorkCheckboxProps> = ({ checked, onChange }) => {
  const { enableEnhancedUx } = useBriefCreationContext();

  return (
    <Stack direction="column" gap="2">
      {enableEnhancedUx && (
        <Text size="b_md" fontWeight="semibold">
          <AppI18n k="sections.need_type.additional_work.subtitle" />
        </Text>
      )}
      <Checkbox
        id={ADDITIONAL_WORK_CHECKBOX_ID}
        marginTop="3"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      >
        <Text size="b_sm" fontWeight={enableEnhancedUx ? 'normal' : 'semibold'}>
          <AppI18n k="sections.need_type.additional_work.title" />
        </Text>
      </Checkbox>
    </Stack>
  );
};
